// extracted by mini-css-extract-plugin
export default {"analysis":"index_analysis__KRokc"};